import React from 'react'
import Typography from "@mui/material/Typography";
import ContentLayout from '../../layout/ChapterContents';

const ChapterContent = () => {
  return (
    <div className="mainDiv">
    <Typography className="heading">Chapter Content</Typography>
   
    <ContentLayout />
    </div>
  )
}

export default ChapterContent
